module.exports = __webpack_public_path__ + "img/home-icon-4.f58976ed.png";